<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part"><p id="rw-p_122093-00001"><a id="pb-rw_7"></a></p><a id="pb-rw_7"> </a><div class="title-block" id="rw-title-block_122093-00001"><a id="pb-rw_7"> </a><h1><a id="pb-rw_7"></a><a href="#/9781847676931_toc">SIX MONTHS EARLIER …</a></h1></div> <p class="fp" id="rw-p_122093-00002"><a id="pb-rw_8"></a></p></div><a id="pb-rw_8">
</a></div><a id="pb-rw_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847676931_part_01.vue?87c279a0